module.exports = __webpack_public_path__ + "img/27_16.09b50502.png";